import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
} from "@material-ui/core";
import roleManager from "../../../Components/roles";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useHistory, useLocation } from "react-router-dom";
import TabsComponent from '../../../Components/Tabs';
import CheckRideTab from "./CheckRideTab";
import TestingEventTab from "./TestingEventTab";
import IncidentTab from "./IncidentTab";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
import AuditTab from "./AuditTab";
import { Tabs } from "antd";




const SafetyTesting = () => {
  const history = useHistory();
  const location = useLocation()
  // const tabState = useState(history?.location?.state?.fromIncident ? 2 : 0);
  const tabState = useState(location?.state?.activeTab || 0);
  const [TabsRender, setTabsRender] = useState([])

  const handleAddEvent = (event, tabIndex) => {
    history.push(event);
  }
  const tabsItems = [
    ...(roleManager("safetyTesting", "testEvent") ? [{
      key: "1",
      label: <span style={{ fontSize: '15px' }}> TESTING EVENTS</span>,
      children: <TestingEventTab />
    }] : []),
    ...(roleManager("safetyTesting", "checkRide") ? [{
      key: "2",
      label: <span style={{ fontSize: '15px' }}> CHECK RIDES</span>,
      children: <CheckRideTab />
    }] : []),
    ...(roleManager("safetyTesting", "incident") ? [{
      key: "3",
      label: <span style={{ fontSize: '15px' }}> INCIDENTS</span>,

      children: <IncidentTab />
    }] : []),
    ...(roleManager("safetyTesting", "Audit") ? [{
      key: "4",
      label: <span style={{ fontSize: '15px' }}> SAFETY AUDIT </span>,

      children: <AuditTab />
    }] : []),

  ]

  return (
    <PageLayout>
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Safety &#38; Testing</Grid>
        <Grid xs={12}>
          <Grid xs={12} >
            <Grid xs={12}  className="LiqTables SafetyTable">
              <Paper >
                <Tabs defaultActiveKey={"" +(location?.state?.activeKey || "1")} items={tabsItems} style={{ fontSize: '20px' }} className="custom-tabs" />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        {/* Page Start End */}
      </Grid>
    </PageLayout>
  );
}

export default SafetyTesting;


